"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "SVBRadio", {
  enumerable: true,
  get: function get() {
    return _SVBRadio.default;
  }
});
var _SVBRadio = _interopRequireDefault(require("./src/SVBRadio"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }